<template>
    <footer
  class="relative lg:fixed lg:-z-10 bg-black bottom-0 w-full pt-20 sm:pt-24 md:pt-36 pb-24 lg:pb-48 overflow-hidden"
>
  <div class="container">
    <!-- Footer Content Grid -->
    <div
      class="flex flex-col sm:flex-row flex-wrap gap-y-10 sm:gap-y-16 justify-center sm:justify-between relative z-10"
    >
      <!-- Reach Us Section -->
      <div class="pr-8 max-lg:basis-full">
        <h5
          class="uppercase text-sm font-satoshi text-white tracking-[3px] mb-4 sm:mb-8 font-bold"
        >
          Reach Us
        </h5>
        <p class="text-white text-sm max-md:font-semibold mb-5">
          Book a quick 15-minute call to see if our<br/> solution is the right fit for you.
        </p>
        <!-- Meeting Scheduler Card -->
        <div
          class="flex p-4 group bg-primary bg-opacity-30 gap-4 justify-between items-center backdrop-blur-2xl max-w-[360px]"
        >
          <img class="h-[30px] w-auto" src="@/assets/images/logo.svg" alt="logo" />
          <div>
            <h6 class="text-sm font-satoshi text-white font-bold">
              Schedule a Free Consultation
            </h6>
          </div>
          <router-link to="/contact">
            <figure
              class="bg-primary w-[55px] h-[55px] cursor-pointer relative overflow-hidden"
            >
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
              />
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute translate-y-12 -translate-x-4 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:translate-x-[19px] group-hover:translate-y-5"
              />
            </figure>
          </router-link>
        </div>
      </div>

      <!-- Resources Links -->
      <div>
        <h5
          class="uppercase text-sm font-satoshi text-white tracking-[3px] mb-4 sm:mb-8 font-bold"
        >
          Links
        </h5>
        <ul>
          <li class="mb-4">
            <router-link
              to="/services"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Services</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/web-development"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Web Development</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/shopify"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Shopify Development</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/contact"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Contact</router-link>
          </li>
        </ul>
      </div>
      <div>
        <h5
          class="uppercase text-sm font-satoshi text-white tracking-[3px] mb-4 sm:mb-8 font-bold"
        >
          Project
        </h5>
        <ul>
          <li class="mb-4">
            <router-link
              to="/pairboard"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Pairboard</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/off-melrose"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Off Melrose</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/finify"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Finify</router-link>
          </li>
          <li class="mb-4">
            <router-link
              to="/blingram"
              class="block text-white transition-colors duration-300 font-semibold hover:text-primary"
              >Blingram</router-link>
          </li>
        </ul>
      </div>
     

    </div>
  </div>

  <!-- Footer Background Text -->
  <div class="absolute w-full bottom-0">
    <h5
      class="w-full bottom-0 absolute footer-text text-center font-satoshi font-extrabold text-4xl xs:text-5xl sm:text-6xl md:text-[88px] lg:text-[120px] xl:text-[150px] 2xl:text-[170px] tracking-widest text-nowrap translate-y-[30%] left-1/2 -translate-x-1/2"
    >
      NEUE MEDIA
    </h5>
  </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>